/**
 * Extracted from `contexts/system-banner-context.tsx` so Fast Refresh can preserve that file's
 * component state. A component file that also exports plain values makes
 * React remount the whole tree on every edit; these values have no JSX in
 * them, so they belong beside the component rather than inside it.
 */

export type SystemBannerVariant = "info" | "warning" | "error" | "success" | "promo"

export type SystemBannerEmphasis = "prominent" | "subtle"

export interface SystemBannerConfig {
  enabled: boolean
  variant: SystemBannerVariant
  emphasis: SystemBannerEmphasis
  title: string
  message: string
  actionLabel?: string
  actionHref?: string
  dismissible: boolean
}

export const DEFAULT_SYSTEM_BANNER_CONFIG: SystemBannerConfig = {
  enabled: true,
  variant: "promo",
  emphasis: "prominent",
  title: "Exxat One Premium",
  message: "Unlock advanced analytics, AI insights, and priority support.",
  actionLabel: "Learn more",
  actionHref: "#",
  dismissible: true,
}
